import React from 'react';

interface ISEOProps extends React.PropsWithChildren {
  title: string;
  path: string;
  description?: string;
}

const DEFAULT_DESCRIPTION =
  'Accident Legal is an expert compensation law firm. We are compensation experts who can offer you our no win-no fee guarantee with no obligation consultation.';

const SEO = ({
  title,
  path,
  description = DEFAULT_DESCRIPTION,
  children,
}: ISEOProps) => {
  const moddedTitle = `${title} | Compensation Experts | Compensation Lawyers Brisbane | Accident Legal`;
  const url = `https://accidentlegal.com${path}`;

  return (
    <>
      <title>{moddedTitle}</title>
      <meta name="description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={moddedTitle} />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:description" content={description} />
      <meta name="og:title" content={moddedTitle} />
      <meta name="og:description" content={description} />
      <meta name="og:type" content="website" />
      <link rel="canonical" href={url} />
      {children}
    </>
  );
};

export { SEO };
export default SEO;
